export const OSS_URL = process.env.VUE_APP_OSS_URL

export const VIDEO_URL = OSS_URL + '/website'
export const IMG_URL = process.env.VUE_APP_OSS_IMG_URL
export const VUE_APP_PUNISH_URL = process.env.VUE_APP_PUNISH_URL
export default {
  OSS_URL,
  VIDEO_URL,
  IMG_URL,
  VUE_APP_PUNISH_URL
}
